import { useDataProvider, useNotify } from "react-admin";
import * as Yup from "yup";
import { Payment } from "./userPayments";
export const useBankedPayeeForm = (
  payment: Payment,
  closeBankedDialog: () => void
) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    accountNumber: Yup.string()
      .test(
        "len",
        "Must be exactly 8 characters",
        (val) => val?.toString().length === 8
      )
      .required("Required"),
    sortCode: Yup.string()
      .test(
        "len",
        "Must be exactly 6 characters",
        (val) => val?.toString().length === 6
      )
      .required("Required"),
  });

  const initialValues = {
    name: "",
    accountNumber: "",
    sortCode: "",
  };

  const refundBankedPayment = async (payeeData) => {
    try {
      const res = await dataProvider.refundBankedPayment({
        reference: payment.groupId,
        amount: payment.total,
        payeeData,
      });
      if (res.data.url) {
        window.open(res.data.url, "_blank");
        closeBankedDialog();
      }
    } catch (err) {
      notify(err.data.error, "error");
      closeBankedDialog();
    }
  };

  const handleFormSubmit = async (values, { setSubmitting }) => {
    await refundBankedPayment(values);

    setSubmitting(false);
  };

  return { initialValues, validationSchema, handleFormSubmit };
};
